<template>
    <section id="faq">
        <h2 ref="faqRef">Frequently Asked Questions</h2>

        <h4 class="mt-10 mb-2">How do we contact you?</h4>
        <p>
            You can contact James on
            <a href="tel:+27836525174">+27 83 652 5174</a>
            or email him at <a href="mailto:jamestpmb@gmail.com">jamestpmb@gmail.com</a>
            or Angela on
            <a href="tel:+27798963702">+27 79 896 3702</a>
            or email her at <a href="mailto:angela.g.clarke99.com">angela.g.clarke99@gmail.com</a>.
        </p>

        <h4 class="mt-10 mb-2">What time should I arrive?</h4>
        <p>
            We ask that you arrive by 2:30 pm and are seated in the ceremony venue by 2:45 pm to ensure that we start on time.
        </p>

        <h4 class="mt-10 mb-2">What is the dress code?</h4>
        <p>
            Formal attire is requested. Ladies, please wear a long dress. Gentlemen, please wear a jacket. However, the most important thing to us is that you are there and have a good time!
        </p>

        <h4 class="mt-10 mb-2">Can I bring a plus one?</h4>
        <p>
            Due to limited space at the venue, we are unfortunately unable to accommodate plus ones. We kindly ask that you stick to the guests listed on your <a href="#rsvp" @click.prevent="$emit('nav-link-click', 'rsvp')">invitation</a>.
        </p>

        <h4 class="mt-10 mb-2">What if I have food allergies or dietary restrictions?</h4>
        <p>
            Please let us know of any food allergies or dietary restrictions in your RSVP submission. We will do our best to accommodate your needs.
        </p>

        <h4 class="mt-10 mb-2">Can I take photos and videos?</h4>
        <p class="mb-2">
            We would love for you to be fully present at the ceremony and therefore ask that you do not take any photos or videos during the ceremony. We have a brilliant professional photographer and videographer who will be capturing all the special moments which we are happy to share afterwards.
        </p>
        <p>
            Please feel free to take as many photos and videos as you want throughout the rest of the evening. We can't wait to see them all!
        </p>

        <h4 class="mt-10 mb-2">Will the wedding be indoors or outdoors?</h4>
        <p>
            Weather permitting, the ceremony will take place in a beautiful outdoor forest chapel. The reception will take place in the indoor reception hall.
        </p>

        <h4 class="mt-10 mb-2">Will there be a bar?</h4>
        <p>
            A selection of alcoholic and non-alcoholic drinks will be provided during the canapés. There will be a cash bar available at the reception.
        </p>

        <h4 class="mt-10 mb-2">How do I get to the venue?</h4>
        <p>
            Turn off the N3 at exit 132 Nottingham Road. Turn left towards the Windmills Country Stop. Continue past the Windmills Country Stop for approximately 5km. The venue will be on your right.
        </p>

        <!-- Embedded Google Map -->
        <div class="map-container">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.7557018274933!2d30.080124210964588!3d-29.318840975194046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef3fea039e06ea9%3A0x7d9f3cdec66cac3d!2sProvidence%20Country%20Estate!5e0!3m2!1sen!2sza!4v1757701371857!5m2!1sen!2sza"
                width="100%"
                height="400"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Wedding Venue Location">
            </iframe>
        </div>
        <a
            href="https://www.google.com/maps/place/Providence+Country+Estate/@-29.318841,30.0801242,17z/data=!3m1!4b1!4m6!3m5!1s0x1ef3fea039e06ea9:0x7d9f3cdec66cac3d!8m2!3d-29.318841!4d30.0827045!16s%2Fg%2F12m984w2r?entry=ttu&g_ep=EgoyMDI1MDkwOS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
        >
            Open in Google Maps
        </a>
	</section>
</template>

<script>
export default {
    name: "FaqSection",
    emits: ["nav-link-click"],
}
</script>

<style scoped>
.map-container {
    margin: 20px 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-container iframe {
    display: block;
    border-radius: 8px;
}

@media (max-width: 768px) {
    .map-container {
        margin: 15px 0;
    }

    .map-container iframe {
        height: 300px;
    }
}
</style>